import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { defaultDoc } from '../share/defaultDoc';
import type { TrafficSafetyScore } from './trafficSafetyScore.types';

export const trafficSafetyScorePullQueryBuilder = (document: TrafficSafetyScore) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query trafficSafetyScoreFeed($lastRequested: DateTime) {
      trafficSafetyScoreFeed(lastRequested: $lastRequested) {
        name
        id
        discipline
        sort
        isActive
        dateModified
      }
    }
  `);

  return {
    query,
    variables: { lastRequested: doc?.dateModified },
  };
};
